import { bindActionCreators } from 'redux';
import { editorReduxStore } from "./redux/store";
import {
  getEditorState,
  useEditorActions,
  useEditorStore,
} from "./redux/hooks";
import { editorThunks } from "./redux/thunks";
import type { EditorSliceState } from "./redux/types";

export type EditorState = EditorSliceState;

export {
  useEditorStore,
  useEditorActions,
  getEditorState as getEditorStoreState,
};

const boundActions = bindActionCreators(
  editorThunks,
  editorReduxStore.dispatch,
);

export function getEditorStore(): EditorSliceState & typeof boundActions {
  return { ...getEditorState(), ...boundActions };
}

export { editorReduxStore, runEditorThunk } from "./redux/store";
